<template>
  <div class="def-input-wrapper">
    <label
      class="def-input"
      :class="{
        'def-input_invalid': !isValid || isError,
        'def-input_success': isSuccess,
        'def-input_small': small,
      }"
    >
      <span
        v-if="!small"
        class="def-input__placeholder"
        :class="{ 'def-input__placeholder_center': !saveValue && !isFocus }"
      >
        {{ placeholder }}
      </span>

      <input
        :id="id"
        :type="type"
        :name="name"
        :required="required"
        :value="saveValue"
        :autocomplete="autocomplete"
        :form="form"
        :readonly="readonly"
        :pattern="pattern"
        :placeholder="small ? placeholder : ''"
        :maxlength="maxlength"
        :inputmode="inputmode"
        class="def-input__input"
        @input="handlerInput"
        @click="$emit('click', $event)"
        @keypress="$emit('keypress', $event)"
        @keydown="$emit('keydown', $event)"
        @keyup="$emit('keyup', $event)"
        @invalid.prevent="handlerInvalid"
        @blur="handlerBlur"
        @focus="handlerFocus"
      />
    </label>
    <span v-if="(!isValid || isShowError) && errorText" class="def-input__error">
      {{ errorText }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'DefInput',
  props: {
    name: String,
    placeholder: String,
    required: Boolean,
    autocomplete: [Boolean, String],
    value: {
      type: String,
      default: '',
    },
    modelValue: {
      type: String,
      default: '',
    },
    id: String,
    form: String,
    type: {
      type: String,
      default: 'text',
    },
    isShowError: {
      type: Boolean,
      default: false,
    },
    isSuccess: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: '',
    },
    pattern: {
      type: [String, null],
      default: null,
    },
    small: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: [String, Number],
      default: null,
    },
    inputmode: {
      type: String,
      // default: 'text',
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isValid: true,
      isFocus: false,
      saveValue: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.saveValue = newValue;
    },
    modelValue(newValue) {
      this.saveValue = newValue;
    },
  },
  mounted() {
    if (this.autofocus) {
      setTimeout(() => {
        const input = this.$el.querySelector('input');
        input?.focus();
      }, 100);
    }
  },
  methods: {
    handlerInput(e) {
      this.saveValue = e.target.value;
      this.$emit('update:modelValue', this.saveValue);
    },
    handlerInvalid(e) {
      if (this.required) {
        this.isValid = false;
      }

      this.$emit('invalid', e);
    },
    handlerBlur(e) {
      const { target } = e;
      if (target.checkValidity() && this.required) {
        this.isValid = true;
      }
      this.isFocus = false;
      this.$emit('blur', e);
    },
    handlerFocus(e) {
      this.isFocus = true;
      this.$emit('focus', e);
    },
  },
};
</script>

<style lang="scss" scoped>
.def-input {
  display: flex;
  align-items: flex-end;
  position: relative;
  height: 52px;
  padding: 8px 16px;
  border: 1px solid #c8c8c8;
  background-color: #fff;
  &_small {
    height: 44px;
    padding: 0;
    .def-input__input {
      height: 100%;
      padding: 0 16px;
    }
  }
  &_invalid {
    border-color: var(--background-red);
  }
  &_success {
    border-color: var(--background-green);
  }
  &__placeholder {
    position: absolute;
    top: 8px;
    color: var(--color-dark-grey);
    transition: 0.2s linear top;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: calc(100% - 32px);
    overflow: hidden;
    font-size: 14px;
    font-weight: 500;
    &_center {
      font-size: rem(16);
      top: 16px;
    }
  }
  &__input {
    font-weight: 500;
    font-size: rem(16);
    border: none;
    height: 20px;
    transition: 0.2s linear border-bottom-color;
    padding: 0;
    width: 100%;
  }
  &__error {
    display: inline-block;
    margin-left: 16px;
    font-size: 14px;
    font-weight: 500;
    line-height: 125%;
    margin-top: 5px;
    color: var(--color-red);
  }
}
</style>
